export enum OLColorEnum {
    blue = 'blue',
    red = 'red',
    green = 'green',
    orange = 'orange',
    pink = 'pink',
    yellow = 'yellow',
    black = 'black',
    white = 'white',
}

export const OLColorMap: Record<OLColorEnum, string> = {
    [OLColorEnum.blue]: '#55A3EC',
    [OLColorEnum.red]:  '#EE0000',
    [OLColorEnum.green]:  '#008800',
    [OLColorEnum.orange]:  '#FF5500',
    [OLColorEnum.pink]:  '#FF00E4',
    [OLColorEnum.yellow]:  '#FFFF00',
    [OLColorEnum.black]:  '#000000',
    [OLColorEnum.white]:  '#ffffff',
}